export default "__VITE_ASSET__Cz2K5pWF__"